import BaseModel from "@model/BaseModel";

import { observable } from "mobx";

export default class EnumContainer extends BaseModel {
  @observable name: string;
}
